// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_2ssRn","badgeButtonWrapper":"_2ssRn","badge-button":"_2Mkqv","badgeButton":"_2Mkqv","badge":"_2xGw1"};